import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SyncContainerTypesToZohoMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type SyncContainerTypesToZohoMutation = { __typename?: 'Mutation', syncContainerTypesToZoho: boolean };


export const SyncContainerTypesToZohoDocument = gql`
    mutation SyncContainerTypesToZoho($ids: [Int!]!) {
  syncContainerTypesToZoho(ids: $ids)
}
    `;
export type SyncContainerTypesToZohoMutationFn = Apollo.MutationFunction<SyncContainerTypesToZohoMutation, SyncContainerTypesToZohoMutationVariables>;

/**
 * __useSyncContainerTypesToZohoMutation__
 *
 * To run a mutation, you first call `useSyncContainerTypesToZohoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncContainerTypesToZohoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncContainerTypesToZohoMutation, { data, loading, error }] = useSyncContainerTypesToZohoMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSyncContainerTypesToZohoMutation(baseOptions?: Apollo.MutationHookOptions<SyncContainerTypesToZohoMutation, SyncContainerTypesToZohoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncContainerTypesToZohoMutation, SyncContainerTypesToZohoMutationVariables>(SyncContainerTypesToZohoDocument, options);
      }
export type SyncContainerTypesToZohoMutationHookResult = ReturnType<typeof useSyncContainerTypesToZohoMutation>;
export type SyncContainerTypesToZohoMutationResult = Apollo.MutationResult<SyncContainerTypesToZohoMutation>;
export type SyncContainerTypesToZohoMutationOptions = Apollo.BaseMutationOptions<SyncContainerTypesToZohoMutation, SyncContainerTypesToZohoMutationVariables>;